export const LIST_TIMESHEETS_ROUTE = "/timesheets";
export const ADD_SITE_TIMESHEET_ROUTE = "/add-timesheet/:siteId";
export const ADD_TIMESHEET_ROUTE = "/add-timesheet";
export const CONFIRM_TIMESHEET_ROUTE = "/confirm-timesheet";
export const ADD_ADMIN_TIMESHEET_ROUTE = "/add-admin-timesheet";
export const ADD_SITE_ADMIN_TIMESHEET_ROUTE = "/add-admin-timesheet/:siteId";
export const LIST_SITE_TIMESHEETS_ROUTE = "/timesheets/:siteId";
export const NEW_LEAVE_PATH = "/timesheets/new-leave";
